import { render } from "./LoadingButton.vue?vue&type=template&id=e5a519f4"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/non/Downloads/soporte.soydelsuda.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__